import React from 'react';

export const UserContext = React.createContext(null);
export const UserProvider = UserContext.Provider;
